import { render, staticRenderFns } from "./chip_points.vue?vue&type=template&id=37242b5a&scoped=true"
import script from "./chip_points.vue?vue&type=script&lang=js"
export * from "./chip_points.vue?vue&type=script&lang=js"
import style0 from "./chip_points.vue?vue&type=style&index=0&id=37242b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37242b5a",
  null
  
)

export default component.exports